import { styled } from "goober";
import type { ComponentProps } from "react";
import { PressButton } from "../PressButton";
import { ButtonContent } from "./ButtonContent";
import { baseStyle, buttonClass, type ButtonStyle } from "./buttonStyle";

const Element = styled(PressButton)`
  ${baseStyle}
`;

type Props = ButtonStyle & Omit<ComponentProps<typeof PressButton>, "children">;

export function ButtonPress({
  variant,
  size,
  icon,
  className,
  children,
  ...props
}: Props) {
  return (
    <Element
      {...props}
      className={buttonClass({ variant, size, icon, children, className })}
    >
      <ButtonContent size={size} icon={icon}>
        {children}
      </ButtonContent>
    </Element>
  );
}
